/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { WrappedFieldInputProps, WrappedFieldProps } from 'redux-form';

import { css, OpenCSSProperties, StyleSheet } from 'aphrodite';
import { mixins } from '@blend/consumer-components';
import { DisplayConfig, InputConfig } from './types';
import { Wrapper as LabelWrapper, ContentWrapper } from '@components/form/Inputs/Label';
import { Wrapper as InputWrapper, Error } from '@components/form/Inputs/InputError';

const styles = StyleSheet.create({
  inputContainer: {
    ...mixins.margin(26, 0),
  },
});

export namespace InputContainer {
  export interface Props extends WrappedFieldProps, DisplayConfig {
    config: InputConfig;
    input: WrappedFieldInputProps;
    required: boolean;
    placeholder?: string;
    disabled?: boolean;
    onClick?(event?: React.FormEvent<any>): void;
    readOnly?: boolean;
    customStyle?: OpenCSSProperties;
  }
}

export const InputContainer: React.FC<InputContainer.Props> = ({
  input,
  meta,
  customStyle = undefined,
  ...otherProps
}) => {
  const { config, required, placeholder, readOnly, disabled, onClick, inputComponent: Input } = otherProps;
  const { label } = config;
  const { touched, error } = meta;
  const invalid = !!(touched && error);
  return (
    <div className={css([styles.inputContainer, customStyle])}>
      {label && (
        <LabelWrapper>
          <ContentWrapper htmlFor={input.name}>{label}</ContentWrapper>
        </LabelWrapper>
      )}
      <Input
        input={input}
        config={config}
        meta={meta}
        id={input.name}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        onClick={onClick}
        aria-invalid={invalid}
        readOnly={readOnly}
      />
      {invalid && (
        <InputWrapper id={`${input.name}-error`}>
          <Error error={error} />
        </InputWrapper>
      )}
    </div>
  );
};

export default InputContainer;
